import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import {
  PanelWrapper,
  OrderNow,
  Address,
  ContactNumber,
  PanelHeader,
  ParsedContent,
  PanelActions,
  Logo
} from './HomePage.style';
import ExceptionalTimes from '../../components/ExceptionalTimes/ExceptionalTimes';

const AboutUsPanel = ({headerColor, orderNowButtonText, preferences, renderTradeShowButton, restaurant}) => {
  const {aboutUsSectionTitle} = restaurant.content;
  const telephoneToUrl = `tel:${restaurant.contactNumber}`;

  const renderLogo = preferences.logo && restaurant.imageLogoUrl && (
      <Logo
        src={`${restaurant.imageLogoUrl}=s480`}
        alt={restaurant.name}
        data-rw="home-page--about-us--restaurant-logo"
      />
    );

  const renderHeader = preferences.header && (
    <PanelHeader headerColor={headerColor}>
      {aboutUsSectionTitle || <FormattedMessage id="home.aboutUs.title" />}
    </PanelHeader>
  );

  const renderContact = preferences.contact && (
    <p data-rw="home-page--restaurant-info">
      <Address data-rw="home-page--about-us--restaurant-content-address">{restaurant.address.singleLine}</Address>
      <FormattedMessage id="contact.tel" />
      <ContactNumber
        href={telephoneToUrl}
        data-rw="home-page--restaurant-phone-number"
      >
        {restaurant.contactNumber}
      </ContactNumber>
    </p>
  );

  const renderOrderButton = preferences.orderButton && (
    <OrderNow
      to="/menu"
      data-rw="home-page--about-us--order-now-link"
    >
      <FormattedMessage id={orderNowButtonText} />
    </OrderNow>
  );

  const renderAlternativeOrderButton = !preferences.orderButton &&
    <PanelActions>{renderTradeShowButton}</PanelActions>;

  const renderExceptionalClosingTimes = restaurant.exceptionalClosingTimes && restaurant.exceptionalClosingTimes.length > 0 &&
    <ExceptionalTimes
      restaurant={restaurant}
      opening={false}
    />;

  const renderExceptionalOpeningTimes = restaurant.exceptionalOpeningTimes && restaurant.exceptionalOpeningTimes.length > 0 &&
    <ExceptionalTimes
      restaurant={restaurant}
      opening={true}
    />;

  return (
    <PanelWrapper>
      {renderHeader}
      <ParsedContent headerColor={headerColor}>
        {renderLogo}
        {renderExceptionalClosingTimes}
        {renderExceptionalOpeningTimes}
        <div
          dangerouslySetInnerHTML={{__html: restaurant.content.aboutUs}} // eslint-disable-line react/no-danger
        />
        {renderContact}
        {renderOrderButton}
      </ParsedContent>
      {renderAlternativeOrderButton}
    </PanelWrapper>
  );
};

AboutUsPanel.propTypes = {
  headerColor: PropTypes.string.isRequired,
  orderNowButtonText: PropTypes.string.isRequired,
  preferences: PropTypes.object.isRequired,
  renderTradeShowButton: PropTypes.func.isRequired,
  restaurant: PropTypes.object.isRequired
};

export default AboutUsPanel;



// WEBPACK FOOTER //
// ./containers/HomePage/AboutUsPanel.js